import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../images/nodata.png'
import { getDocumentByUserId, DirectDownloadAnyFileByFileName, downloadDocumentFileByTypes } from '../../AdminActionCreator.component';

import Loader from '../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../presentationals/Popup/Popup.component';
const itemsPerPage = 10;
export default function Main({ allDetail, userDetails }) {

    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])

    const [currentPage, setcurrentPage] = useState(1)
    const [AddDocumentPopup, setAddDocumentPopup] = useState(false);
    const [viewDocumentPopup, setViewDocumentPopup] = useState({ show: false, data: {} })
    const [uploadDocumentData, setuploadDocumentData] = useState({ file: '', documentNameSelected: '', documentName: '' })
    const [ListData, setListData] = useState([])
    const [popupListData, setPopupListData] = useState([])
    const [disableSelectBox, setdisableSelectBox] = useState(false)
    const [PopupData, setPopupData] = useState({ show: false, popupData: '' })
    const [totalDocs, setTotalDocs] = useState(0)





    const actionHandler = (type, data) => {
        if (type === "view") {
            setViewDocumentPopup({ show: true, data: data })


        } else if (type === "closePopup") {
            setdisableSelectBox(false)
            setPopupListData([])
            setListData([])
            setAddDocumentPopup(false)
            setuploadDocumentData({ file: '', documentNameSelected: '', documentName: '' })
            setViewDocumentPopup({ show: false, data: {} })
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        getDocumentByUserIdAPI(value)
    }



    useEffect(() => {
        getDocumentByUserIdAPI(currentPage)
    }, [])

    const getDocumentByUserIdAPI = (page) => {
        setLoader(true)
        getDocumentByUserId(page, itemsPerPage, allDetail?.userId, (callback) => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                settableData(callback?.data)
                
            } else {
                settableData([])

            }
        })
    }



    const getDates = (time) => {

        const date = new Date(time);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

   


    const handleDownloadDoc = (data) => {
        const [before, after] = data?.documentUrl?.split("?downloadfile=");
        const [newbef, newaft] = after?.split("&type=")
        setLoader(true)
        downloadDocumentFileByTypes(newbef, newaft, callback => {
            setLoader(false)
        })
    }


    return (
        <>
            {
                loader ? <Loader /> : ''
            }

            {
                PopupData?.show ?
                    <Popup
                        closePopup={closePopup}
                        popupStatus={PopupData?.popupData}
                    />
                    : ''}
            <div className="container-fluid" style={{ marginTop: '50px' }}>
                <div className="row">

                    <div className="col-xs-12">
                        <div className='table-responsive '>
                            {tableData?.length > 0 ?
                                <>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table'>
                                            <thead>
                                                <tr>
                                                    <th scope="col">Document Name</th>
                                                    {/* <th scope='col'>Document Type</th> */}
                                                    <th scope='col'>Added On</th>

                                                    <th scope="col">Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData?.map((row, i) => {
                                                    return (
                                                        <tr key={i}>


                                                            <td>{row?.documentName || "-"}</td>
                                                            {/* <td>{row?.documentType || "-"}</td> */}
                                                            <td>{getDates(row?.addedOn) || "-"}</td>
                                                            <td>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <i className="fa fa-download" onClick={e => handleDownloadDoc(row)} style={{ marginRight: '15px' }} />
                                                                    <i className="fa fa-eye" onClick={e => actionHandler('view', row)} style={{ marginRight: '15px' }} />
                                                                    {/* <i className='fa fa-edit' onClick={e => actionHandler('edit', row)} style={{ marginRight: '15px' }} /> */}
                                                                    
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination
                                        count={Math.ceil(totalDocs / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        style={{ display: 'flex', justifyContent: 'end' }}
                                    /> */}
                                </>
                                :
                                <p style={{ marginTop: '100px' }} className="text-center">
                                    <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                                </p>
                            }
                        </div>
                    </div>


                </div>



                {
                    viewDocumentPopup?.show ?
                        <div className="popup-main  container-fluid   " style={{ padding: '20px', borderRadius: '10px', width: '800px', height: '500px' }}>
                            <i onClick={() => actionHandler("closePopup", "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h5 className="" style={{ marginBottom: '5px', marginTop: '5px', fontWeight: '700' }}><i class="fa fa-file-text" aria-hidden="true" style={{ fontSize: '20px' }}></i>&nbsp;&nbsp; View {viewDocumentPopup?.data?.documentName || "Document"}</h5>
                                </div>

                                <div className="col-xs-12" style={{ marginTop: '25px' }}>
                                    <div style={{ width: '100%', height: '360px', marginTop: '15px' }}>
                                        <iframe src={viewDocumentPopup?.data?.documentUrl} width={"100%"} height={"100%"}></iframe>
                                    </div>
                                </div>
                            </div>

                        </div>
                        : ''}



            </div>
        </>
    )
}
